import { getCurrentInstance } from "vue";

/**
 * The translation composable.
 */
export default function useTranslation() {
  const $vm = getCurrentInstance()?.proxy;
  const translate = (key, ...rest) => $vm.$t(key, ...rest);

  return {
    translate,
    __: translate,
  };
}
